import { useAppPersistenceStore } from '@ninjacart/nc-nk-store';
import { Input, Text, XStack, useTheme } from '@ninjacart/nc-nk-ui';
import { Mic, Search } from '@tamagui/lucide-icons';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
// import Voice from '@wdragon/react-native-voice';

interface IGlobalAnimationSearchProps {
  handleSearch: (value: boolean) => void;
}

const GlobalAnimationSearch = ({ handleSearch }: IGlobalAnimationSearchProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const appLanguage = useAppPersistenceStore((state) => state.appLanguage);

  return (
    <Pressable onPress={() => handleSearch(false)} style={{ width: '100%' }}>
      <XStack width={'100%'} marginTop={4}>
        <XStack position="absolute" zIndex={1} top={10} left={12}>
          <Search color={theme['grey']?.val} size={22} />
          <Text paddingLeft={10} color="$grey"  fontSize={ appLanguage == 'ta' ? 14 : 16 }>
            {t('page.feedSearchPlaceholder')}
          </Text>
        </XStack>
        <Input
          size="$4"
          width={'100%'}
          paddingLeft={10}
          borderWidth={1}
          backgroundColor={'$inputBg'}
          borderColor={'$grey'}
          borderRadius={5}
          color={'$usertextColor'}
          style={{ fontWeight: '500', paddingLeft: 50 }}
          editable={false}
          height={44}
          testID="kisan_tId_SearchInput"
        />
        <XStack
          position="absolute"
          zIndex={1}
          top={8}
          right={12}
          padding={4}
          borderRadius={20}
          backgroundColor="$primary"
          justifyContent="center"
          alignItems="center"
          onPress={() => handleSearch(true)}
        >
          <Mic color={'#fff'} size={20} />
        </XStack>
      </XStack>
    </Pressable>
  );
};

export default GlobalAnimationSearch;
